import { noop } from 'lodash';
import { ReactElement } from 'react';

import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { VisitUpdateInterviewCommand } from '@dreryk/egabinet-visit-frontend-api';

import { TextEditorValue } from '@dreryk/react-text-editor';
import { FieldController } from '@dreryk/react-common';
import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

import { visitDetailsTranslationKeys } from '../../../translations';
import { VisitFormTextEditor } from '../shared/VisitFormTextEditor';

type InterviewTextEditorProps = {
   readonly controller: FieldController<TextEditorValue | null>;
   readonly practitionerId: PractitionerId;
   readonly visitId: number;
   readonly labelSuffix: ReactElement;
};

export const InterviewTextEditor = (props: InterviewTextEditorProps): JSX.Element => {
   const { executeAsync: updateInterview } = useCqrsCommand<void, { value: TextEditorValue | null }>(
      ({ value }) => {
         const command = new VisitUpdateInterviewCommand();
         command.id = props.visitId;
         command.interview = Choice.withUseDefaultIfNull(value?.getFormattedValue() ?? null);
         return command;
      },
      {
         onUnexpectedError: noop,
      }
   );

   return (
      <VisitFormTextEditor
         testId={'interview'}
         placeholder={visitDetailsTranslationKeys.interviewPlaceholder}
         modalLabel={visitDetailsTranslationKeys.interview}
         label={visitDetailsTranslationKeys.interview}
         labelSuffix={props.labelSuffix}
         controller={props.controller}
         practitionerId={props.practitionerId}
         onAutoSave={updateInterview}
      />
   );
};
